window.Products.Clothing.ClassicCrewneck = function() {
};
window.Products.Clothing.ClassicCrewneck.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ClassicCrewneck.dpi = 150;
window.Products.Clothing.ClassicCrewneck.has_3d = true;
window.Products.Clothing.ClassicCrewneck.id = 109;
window.Products.Clothing.ClassicCrewneck.slug = 'classic-crewneck';
window.Products.Clothing.ClassicCrewneck.syncColors = true;
window.Products.Clothing.ClassicCrewneck.texturesLoaded = 0;
window.Products.Clothing.ClassicCrewneck.texturesLoading = false;
window.Products.Clothing.ClassicCrewneck.use_glb = true;

window.Products.Clothing.ClassicCrewneck.prototype.outsideObject = 0;
window.Products.Clothing.ClassicCrewneck.prototype.detailsObject = 1;
window.Products.Clothing.ClassicCrewneck.prototype.position = 0.1;

window.Products.Clothing.ClassicCrewneck.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color == "ash" || color == "sport_grey"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.ClassicCrewneck.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"antique_cherry_red": 0xab0c2a,
		"ash": 0xcbc7c4,
		"cardinal_red": 0x8d002a,
		"charcoal": 0x4c4f56,
		"dark_chocolate": 0x463c3a,
		"dark_heather": 0x47464b,
		"gold": 0xfeb53d,
		"heliconia": 0xe74382,
		"navy": 0x2b2d42,
		"royal": 0x2d63ad,
		"sand": 0xccbcae,
		"sport_grey": 0xa4a3ab,
	};

	return new THREE.Color(colors[_name]);
};